import React, { Dispatch, SetStateAction } from 'react';
import {
  Grid,
  GridItem,
  Text,
  FormControl,
  FormLabel,
  Input,
  Link,
  Box,
  Checkbox,
} from '@chakra-ui/react';
import { KeysavvyInfo } from 'src/api/v1-api';
import { ExternalLinkIcon } from '@chakra-ui/icons';

interface KeysavvyInfoFormProps {
  keysavvyInfo: KeysavvyInfo;
  setKeysavvyInfo: Dispatch<SetStateAction<KeysavvyInfo | null>>;
}

const KeysavvyInfoForm: React.FC<KeysavvyInfoFormProps> = ({ keysavvyInfo, setKeysavvyInfo }) => {
  const handleVIN = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parsedVin = e.target.value.trim().toUpperCase();
    setKeysavvyInfo({ ...keysavvyInfo, vin: parsedVin } as KeysavvyInfo);
  };

  const handleSellerAccept = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKeysavvyInfo({ ...keysavvyInfo, seller_accept: e.target.checked } as KeysavvyInfo);
  };

  return (
    <Box
      bg="green.50"
      borderWidth="2px"
      borderColor="green.400"
      borderRadius="md"
      p={{ base: 4, md: 6 }}
      my={{ base: 4, lg: 6 }}
    >
      <Text fontSize="md" fontWeight={600} mb={{ base: 3, md: 4 }}>
        SafePay with KeySavvy
      </Text>

      <Grid
        width="full"
        templateColumns="repeat(4, 1fr)"
        gap={{ base: 3, md: 5 }}
        mb={{ base: 4, md: 6 }}
      >
        <GridItem colSpan={4}>
          <Text fontSize="sm" fontWeight={500} color="gray.600">
            Our SafePay service is powered by KeySavvy, the leading provider in secure vehicle
            transactions. SafePay handles the entire transaction process, ensuring a smooth and
            secure experience for both buyers and sellers.
            <br />
            <br />
            <Link href="https://safepay.withloma.com/how-it-works" isExternal color="blue.500">
              How SafePay works
              <ExternalLinkIcon marginBottom={1} marginLeft={1} />
            </Link>
          </Text>
        </GridItem>
        <GridItem colSpan={{ base: 4, md: 2 }}>
          <FormControl>
            <FormLabel>Vehicle Identification Number (VIN)</FormLabel>
            <Input
              type="text"
              name="keysavvy_vin"
              borderColor="gray.300"
              placeholder="VIN"
              value={keysavvyInfo?.vin ?? ''}
              onChange={handleVIN}
              isRequired
            />
          </FormControl>
          <FormControl mt={6}>
            <Checkbox
              name="keysavvy_seller_accept"
              borderColor="gray.300"
              isChecked={keysavvyInfo?.seller_accept ?? false}
              onChange={handleSellerAccept}
              isRequired
            >
              I accept the KeySavvy Terms of Service
            </Checkbox>
          </FormControl>
        </GridItem>
      </Grid>

      <Text fontSize={'sm'} fontWeight={600} my={{ base: 4, lg: 6 }}>
        More information will be required to complete a transaction through KeySavvy, but may be
        provided after a buyer has committed to purchase.
      </Text>
    </Box>
  );
};

export default KeysavvyInfoForm;
